/**
 * Medute Wishlist — cookie-based, replaces the old wbwishList implementation.
 * Works across product cards, product page, quick view, and the wishlist page.
 */
(function() {
  'use strict';

  var WISHLIST_COOKIE = 'wbwishList';
  var SEPARATOR = '__';

  function getCookie(name) {
    if (typeof jQuery !== 'undefined' && jQuery.cookie) {
      return jQuery.cookie(name);
    }
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    days = days || 14;
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
  }

  function parseHandles(value) {
    if (!value || value === SEPARATOR || value === '') return [];
    return String(value)
      .split(SEPARATOR)
      .map(function(h) { return h.trim(); })
      .filter(function(h) { return h !== ''; });
  }

  function serializeHandles(handles) {
    if (!handles.length) return SEPARATOR;
    return SEPARATOR + handles.join(SEPARATOR) + SEPARATOR;
  }

  window.MeduteWishlist = {
    getItems: function() {
      var handles = parseHandles(getCookie(WISHLIST_COOKIE));
      var unique = [];
      handles.forEach(function(handle) {
        if (unique.indexOf(handle) === -1) unique.push(handle);
      });
      return unique;
    },

    contains: function(handle) {
      return this.getItems().indexOf(handle) !== -1;
    },

    add: function(handle) {
      handle = String(handle).trim();
      if (!handle) return;
      // Re-read the cookie right before writing to avoid duplicate race conditions.
      var items = this.getItems();
      if (items.indexOf(handle) === -1) {
        items.push(handle);
        setCookie(WISHLIST_COOKIE, serializeHandles(items));
      }
      this.updateUI();
    },

    remove: function(handle) {
      handle = String(handle).trim();
      var items = this.getItems().filter(function(h) { return h !== handle; });
      setCookie(WISHLIST_COOKIE, serializeHandles(items));
      this.updateUI();
    },

    toggle: function(handle) {
      if (this.contains(handle)) {
        this.remove(handle);
        return false;
      } else {
        this.add(handle);
        return true;
      }
    },

    count: function() {
      return this.getItems().length;
    },

    updateCounter: function() {
      var count = this.count();
      var $counter = jQuery('.medute-wishlist-count');
      if ($counter.length) {
        $counter.attr('data-count', count).text(count > 99 ? '99+' : count);
        $counter.toggleClass('medute-wishlist-count--empty', count === 0);
      }
    },

    updateButtons: function() {
      var items = this.getItems();
      jQuery('.default-wishbutton, .loadding-wishbutton, .added-wishbutton').hide();

      items.forEach(function(handle) {
        jQuery('.default-wishbutton-' + handle).hide();
        jQuery('.loadding-wishbutton-' + handle).hide();
        jQuery('.added-wishbutton-' + handle).css('display', '').show();
      });

      jQuery('.medute-product-card__wishlist, .medute-product__wishlist, .add-to-wishlist').each(function() {
        var $wrap = jQuery(this);
        var handle = $wrap.find('.add-in-wishlist-js, .add_to_wishlist').attr('href');
        if (!handle) return;
        handle = handle.replace(/^\//, '').split('?')[0];
        if (items.indexOf(handle) !== -1) {
          $wrap.find('.default-wishbutton-' + handle).hide();
          $wrap.find('.loadding-wishbutton-' + handle).hide();
          $wrap.find('.added-wishbutton-' + handle).css('display', '').show();
        } else {
          $wrap.find('.default-wishbutton-' + handle).css('display', '').show();
          $wrap.find('.loadding-wishbutton-' + handle).hide();
          $wrap.find('.added-wishbutton-' + handle).hide();
        }
      });
    },

    updateUI: function() {
      this.updateCounter();
      this.updateButtons();
    },

    playToggleSound: function() {
      try {
        var AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        var ctx = new AudioContext();
        var osc = ctx.createOscillator();
        var gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = 'sine';
        osc.frequency.setValueAtTime(880, ctx.currentTime);
        osc.frequency.exponentialRampToValueAtTime(440, ctx.currentTime + 0.08);
        gain.gain.setValueAtTime(0.2, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.08);
        osc.start();
        osc.stop(ctx.currentTime + 0.1);
      } catch (e) {}
    },

    initButtons: function() {
      var self = this;
      // Use event delegation so dynamically injected cards also work.
      jQuery(document)
        .off('click.meduteWishlist', '.add-in-wishlist-js, .added-wishlist')
        .on('click.meduteWishlist', '.add-in-wishlist-js, .added-wishlist', function(event) {
          event.preventDefault();
          var $link = jQuery(this);
          var handle = String($link.attr('data-handle') || $link.attr('href') || '').replace(/^\//, '').split('?')[0];
          if (!handle || handle === '/pages/wishlist') {
            // Fallback: read handle from the closest wrapper.
            var $wrap = $link.closest('[data-wishlist-handle]');
            handle = $wrap.attr('data-wishlist-handle') || '';
          }
          if (!handle) return false;

          var added = self.toggle(handle);
          self.playToggleSound();

          // Swap states immediately for the clicked wrapper.
          var $wrap = $link.closest('.medute-product-card__wishlist, .medute-product__wishlist, .add-to-wishlist, .product-container');
          if ($wrap.length) {
            $wrap.find('.default-wishbutton-' + handle).toggle(!added);
            $wrap.find('.loadding-wishbutton-' + handle).hide();
            $wrap.find('.added-wishbutton-' + handle).toggle(added);
          }

          self.updateUI();
          return false;
        });
    },

    deduplicateCookie: function() {
      var items = this.getItems();
      var unique = [];
      items.forEach(function(handle) {
        if (unique.indexOf(handle) === -1) unique.push(handle);
      });
      if (unique.length !== items.length) {
        setCookie(WISHLIST_COOKIE, serializeHandles(unique));
      }
    },

    renderWishlistPage: function() {
      var pageContainer = document.querySelector('[data-medute-wishlist-page]');
      if (!pageContainer) return;

      var box = pageContainer.querySelector('.wishlist-box');
      if (!box) return;

      var templates = {
        item: pageContainer.querySelector('.wishlist-item'),
        name: pageContainer.querySelector('.wishlist-item-name'),
        price: pageContainer.querySelector('.table-wishlist-1__product-price'),
        clear: pageContainer.querySelector('.wishlist-item-clear'),
        stock: pageContainer.querySelector('.wishlist-stock'),
        continueBtn: pageContainer.querySelector('.wishlist-item-continue')
      };

      if (!templates.item || !templates.name || !templates.price || !templates.clear || !templates.stock || !templates.continueBtn) return;

      function formatMoney(price) {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          return Shopify.formatMoney(price, window.money_format || '${{amount}}');
        }
        return '$' + (price / 100).toFixed(2);
      }

      function emptyWishlist() {
        box.innerHTML = '<tr><td colspan="6" class="medute-wishlist-empty">Your wishlist is empty. <a href="/collections/all">Continue shopping</a>.</td></tr>';
      }

      function removeRow(row, handle) {
        if (window.MeduteWishlist) window.MeduteWishlist.remove(handle);
        row.style.transition = 'opacity .3s';
        row.style.opacity = '0';
        setTimeout(function() {
          row.remove();
          if (box.querySelectorAll('tr').length === 0) emptyWishlist();
        }, 300);
      }

      function buildRow(product) {
        var cloneItem = templates.item.cloneNode(true);
        cloneItem.style.display = '';
        var img = cloneItem.querySelector('.img-responsive');
        var link = cloneItem.querySelector('.wishlist-item-link');
        if (img) img.src = product.featured_image || '';
        if (link) link.href = product.url;

        var cloneName = templates.name.cloneNode(true);
        cloneName.style.display = '';
        var nameLink = cloneName.querySelector('.wishlist-item-link');
        if (nameLink) {
          nameLink.href = product.url;
          nameLink.textContent = product.title;
        }

        var clonePrice = templates.price.cloneNode(true);
        clonePrice.style.display = '';
        clonePrice.innerHTML = '<span class="money">' + formatMoney(product.price) + '</span>';

        var cloneClear = templates.clear.cloneNode(true);
        cloneClear.style.display = '';
        var removeLink = cloneClear.querySelector('.product-remove-js');

        var cloneStock = templates.stock.cloneNode(true);
        cloneStock.style.display = '';
        var stockSpan = cloneStock.querySelector('.wishlist-in-stock');
        if (stockSpan) {
          if (product.available) {
            stockSpan.textContent = window.in_stock || 'In stock';
          } else {
            stockSpan.classList.add('wishlist-out-of-stock');
            stockSpan.textContent = window.out_of_stock || 'Out of stock';
          }
        }

        var cloneContinue = templates.continueBtn.cloneNode(true);
        cloneContinue.style.display = '';
        var continueLink = cloneContinue.querySelector('.wishlist-item-link');
        if (continueLink) continueLink.href = product.url;

        var row = document.createElement('tr');
        row.className = product.handle;

        var cells = [
          { className: 'medute-wishlist-table__remove', html: cloneClear.innerHTML },
          { className: 'medute-wishlist-table__image', html: cloneItem.innerHTML },
          { className: 'medute-wishlist-table__name', html: cloneName.innerHTML },
          { className: 'medute-wishlist-table__price', html: clonePrice.innerHTML },
          { className: 'medute-wishlist-table__stock', html: cloneStock.innerHTML },
          { className: 'medute-wishlist-table__action', html: cloneContinue.innerHTML }
        ];

        cells.forEach(function(cell) {
          var td = document.createElement('td');
          td.className = cell.className;
          td.innerHTML = cell.html;
          row.appendChild(td);
        });

        if (removeLink) {
          row.querySelector('.product-remove-js').addEventListener('click', function(event) {
            event.preventDefault();
            removeRow(row, product.handle);
          });
        }

        return row;
      }

      box.innerHTML = '';

      var handles = this.getItems();
      if (!handles.length) {
        emptyWishlist();
        return;
      }

      var completed = 0;
      var rendered = 0;
      var fetchedHandles = {};
      function checkComplete() {
        completed++;
        if (completed === handles.length && rendered === 0) {
          emptyWishlist();
        }
      }

      handles.forEach(function(handle) {
        if (fetchedHandles[handle]) {
          checkComplete();
          return;
        }
        fetchedHandles[handle] = true;
        fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function(res) {
            if (!res.ok) throw new Error('Product not found');
            return res.json();
          })
          .then(function(product) {
            var row = buildRow(product);
            box.appendChild(row);
            rendered++;
            checkComplete();
          })
          .catch(function() {
            // Product no longer exists; remove from wishlist.
            if (window.MeduteWishlist) window.MeduteWishlist.remove(handle);
            checkComplete();
          });
      });
    },

    init: function() {
      if (this._initialized) return;
      if (typeof jQuery === 'undefined') {
        var self = this;
        setTimeout(function() { self.init(); }, 100);
        return;
      }
      this._initialized = true;
      this.deduplicateCookie();
      this.updateUI();
      this.initButtons();
      this.renderWishlistPage();
    }
  };

  // Auto-init when DOM is ready.
  if (typeof jQuery !== 'undefined') {
    jQuery(function() {
      window.MeduteWishlist.init();
    });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      if (typeof jQuery !== 'undefined') window.MeduteWishlist.init();
    });
  }
})();
